import { testimonials } from '@/mocks/testimonials';

export default function Testimonials() {
  return (
    <section className="py-20 md:py-28 bg-background-200">
      <div className="w-full max-w-6xl mx-auto px-6 md:px-10">
        <div className="text-center mb-14">
          <div className="flex items-center justify-center gap-2 mb-3">
            <span className="w-2 h-2 rounded-full bg-accent-500"></span>
            <span className="font-label text-xs text-primary-600 tracking-[0.2em] uppercase">
              Community Verified
            </span>
          </div>
          <h2 className="section-title mb-3">
            Trusted By Thousands
            <br />
            Of Smart Shoppers
          </h2>
          <p className="section-subtitle mx-auto">
            Real feedback from real shoppers who use SuperBuy Spreadsheet every day.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {testimonials.map((t, index) => (
            <div
              key={t.name}
              className="bg-white rounded-xl p-6 border border-background-200 transition-all duration-300 hover:border-background-300"
            >
              <div className="flex items-center gap-0.5 mb-4">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-amber-400 text-sm"></i>
                ))}
              </div>
              <h4 className="font-heading text-base font-semibold text-foreground-900 mb-2">
                {t.title}
              </h4>
              <p className="font-body text-sm text-foreground-500 leading-relaxed mb-5">
                {t.content}
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-background-100">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="w-10 h-10 rounded-full object-cover flex-shrink-0"
                  loading="lazy"
                />
                <div>
                  <p className="font-body text-sm font-semibold text-foreground-900">{t.name}</p>
                  <p className="font-body text-xs text-foreground-400">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}